// extracted by mini-css-extract-plugin
export var boldParagraph = "styles-module--bold-paragraph--a1407";
export var firstGlow = "styles-module--first-glow--ad401";
export var image = "styles-module--image--cd25d";
export var mainContent = "styles-module--main-content--6d44c";
export var specialColor = "styles-module--special-color--192c4";
export var title = "styles-module--title--980ea";
export var wrapper = "styles-module--wrapper--b4677";